import { FC } from "react";
const NearbyIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18"         fill="currentcolor"
 {...props}>
      <path
        d="M9.9 18.0002L7.05 10.9502L0 8.10024V6.70024L18 0.000244141L11.3 18.0002H9.9ZM10.55 14.3002L14.6 3.40024L3.7 7.45024L8.6 9.40024L10.55 14.3002Z"
      />
    </svg>
  );
};

export default NearbyIcon;
